const professionalExp = [
    {
      employer: 'College of the Mainland',
      title: 'Programmer Analyst',
      date: 'Jan 2020 - Present',
      description:
        'COLLEGE OF THE MAINLAND | ellucian colleague programer and support administrator for the community college.',
      image: process.env.PUBLIC_URL + '/images/com.jpg',
      imageText: 'College of the Mainland',
      details: [
        "Post-help desk IT Support for entire College",
        "Administrator for ERP system - Ellucian Colleague",
        "Account management, creation, termination, record security",
        "3rd party implementations with ERP system",
        "Data import/export, sftp (ex: Blackboard AdAstra, EAB)",
        "Reporting from ERP system",
        "Custom reporting via ERP programming, terminal data, or via reporting tool",
        "Custom modifications of ERP system via a modified version of Eclipse IDE called Colleague Studio",
        "Implementation and maintenance of ApplyTexas student applications and transcripts via EDI exchange with SPEEDE servers",
        "Remote work for 1.5 years due to COVID-19 pandemic",
      ],
      techUsed: [
        "Ellucian’s Colleague/WebAdvisor/Self-Service", "Unidata", "Unibasic", "Uniquery", "Colleague Studio",
         "Remote Desktop", "VMCenter", "PuTTY", "Perceptive Content", "Informer", "Microsoft Office 365 Suite",
          "Sharepoint", "Teams", "Zoom"
      ],
      link: 'https://www.com.edu/',
    },
    {
      employer: 'Coastal Carolina University',
      title: 'Applications Analyst II',
      date: 'Jan 2014 - Dec 2019',
      description:
        'COASTAL CAROLINA UNIVERSITY | ellucian colleague programmer and support for the office of financial services',
      image: process.env.PUBLIC_URL + '/images/ccu.png',
      imageText: 'Coastal Carolina University',
      details:[
        "IT Support for the Office of Financial Services (Accounts Payable, Accounts Receivable, Accounting, Payroll, Procurement, special projects from CFO and Controller’s office)",
        "Member of the Student Success team devoted to ensuring members from all departments in the University met and worked together",
        "Administrator for ERP system - Ellucian Colleague, Colleague Finance module",
        "Accounting account management, creation, termination, record security",
        "3rd party implementations with ERP system",
        "Phases of discovery, implementing, testing, installing, administering",
        "Project management, workflows, scripting",
        "Data import/export, sftp (ex: Jaggaer/SciQuest, Bank of America, Softdocs)",
        "Reporting from ERP system",
        "Custom reporting via ERP custom programming or terminal database access",
        "Reporting tools such as Synoptix or Entrinsik’s Informer (utilizes JavaScript)",
        "Custom modifications of ERP system via a modified version of Eclipse IDE called Colleague Studio",
        "Tax Processing and Reporting for 1099-MI and 1099-K forms",
        "Administer of Hyland’s Perceptive Content (university imaging system), Synoptix (business reporting tool), Entrinsik’s Informer (ERP reporting tool), Softdocs (check printing)",
        "Backup for another programmer who handled Student Accounts department",
      ],
      techUsed: [
        "Ellucian’s Colleague/WebAdvisor/Self-Service", "Unidata", "Unibasic", "Uniquery", "Colleague Studio",
         "Remote Desktop", "VMCenter", "PuTTY", "Perceptive Content", "Informer", "Synoptix", "Softdocs",
          "Microsoft Office 365 Suite"
      ],
      link: 'https://www.coastal.edu/',
    },
    {
      employer: 'Primary Solutions, Inc',
      title: 'Software Engineer',
      date: 'Jan 2011 - Dec 2013',
      description:
        'PRIMARY SOLUTION INC | powerbuilder developer serving the developmentally disabled community of ohio.',
      image: process.env.PUBLIC_URL + '/images/psi.jpg',
      imageText: 'Primary Solutions',
      details: [
        "Developer for products: Gatekeeper, Advisor, Anywhere, CustomerCare, Up2Date",
        "Gatekeeper and Advisor are applications made for the Ohio Developmental Disabilities community. Code is maintained in Powerbuilder and uses a SQL Anywhere Sybase backend. These client-server apps also have an extensive reporting section. Responsible for code bug fixes and enhancements including updates to stored procedures and triggers in the database.",
        "Anywhere 1.0 is an ASP.NET/VB.NET web application that acts as a simplified online version of Gatekeeper and Advisor. Wrote web service calls in C#. Anywhere 2.0 was a complete redesign of Anywhere 1.0. Revised the entire model from the front end and UI to business layers and to database level. Web application was translated into a JavaScript (official and jQuery), Html5, AJAX frontend and C# middle tier.",
        "Wrote CustomerCare in VB.NET that calls web services in C# that runs on a client’s server to send messages to a client or retrieve information requested by OhioDD. ",
        "Translated Up2Date from VB 6.0 to C#. This program calls web services written in C# to determine if the version on a machine is the latest release.",
        "Position also includes a backup support role for customers.",
        "Testing and User Acceptance for every application",
        "Handled upgrades of certain clients that involved running SQL scripts on client machines and extracting databases.",
        "Pre-release version of an android app for Gatekeeper using Mobilink",
      ],
      techUsed: [
        "Powerbuilder", "Java", "C#", "ASP.NET", "VB 6.0", "VB.NET", "XML", "SQL Anywhere", "MySQL", "ConnectWise",
         "Microsoft Office 2012", "JavaScript", "jQuery", "CSS", "ODBC", "Stored Procedures", "Visual Studio.net",
          "Sybase", ".NET Framework 3.5/4.0", "Remote Desktop", "VMWare", "GoToMeeting"
      ],
      link: 'http://primarysolutions.net/',
    },
    {
      employer: 'Sophos Group',
      title: 'Software Engineer - Intern',
      date: 'Jun 2010 - Sep 2010',
      description:
        'SOPHOS GROUP | college intern working on unit testing and messaging with the network access control agent.',
      image: process.env.PUBLIC_URL + '/images/sophos.jpg',
      imageText: 'Sophos',
      details: [
        "Intern work for the Sophos Network Access Control (NAC) Agent",
        "Worked on the NAC Agent (Network Access Control) ",
        "Updated legacy code to today’s models, standards and developments all in C#.",
        "Added logging features to the code (C#)",
        "Helped develop a new messaging protocol for inter-use in the application",
        "Testing and acceptance for logging features",
      ],
      techUsed: [
        "C#", "Perforce (Source Control)", "CruiseControl", "VisualStudio.NET 2008", "MbUnit", "Resharper",
        "StyleCop", "VMWare/vSphere"
      ],
      link:'https://www.sophos.com/en-us.aspx',
    },
  ];

export default professionalExp;